import React, { useEffect } from 'react';
import { formatDate } from '../utils/dateFormat';
import { Logo } from '../components/Logo';
import { LegalFooter } from '../components/LegalFooter';
import { ThemeToggle } from '../components/ThemeToggle';
import { Button } from '@/components/ui/button';

function TermsPage() {
  useEffect(() => {
    document.title = 'Terms of Service | PATH by Secret Sauce';
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <header className="border-b border-border bg-card">
        <div className="container-custom py-4">
          <div className="flex items-center justify-between">
            <a href="/">
              <Logo variant="full" size="default" />
            </a>
            <div className="flex items-center gap-3">
              <ThemeToggle />
              <Button asChild variant="ghost" size="sm">
                <a href="/login">Login</a>
              </Button>
            </div>
          </div>
        </div>
      </header>

      <main className="container-custom py-12 max-w-4xl flex-1">
        <h1 className="h1 mb-8">Terms of Service</h1>
        
        <div className="prose prose-slate dark:prose-invert max-w-none">
          <p className="body text-lg mb-6">
            Last updated: {formatDate(new Date())}
          </p>

          <h2 className="h2 text-2xl mt-8 mb-4">1. Acceptance of Terms</h2>
          <p className="body mb-4">
            By accessing and using the PATH Programme platform operated by Secret Sauce 
            (a trading name of Organisation Logic Limited), you agree to be bound by these 
            Terms of Service and all applicable laws and regulations.
          </p>

          <h2 className="h2 text-2xl mt-8 mb-4">2. Description of Service</h2>
          <p className="body mb-4">
            The PATH Programme provides leadership diagnostics (EDGE and CORE), personalised 
            insights, facilitated sessions, and development programmes for senior professionals. 
            The service is designed for professional development purposes.
          </p>

          <h2 className="h2 text-2xl mt-8 mb-4">3. User Accounts</h2>
          <p className="body mb-4">
            You are responsible for maintaining the confidentiality of your account and for all 
            activities that occur under your account. You agree to notify us immediately of any 
            unauthorised use of your account.
          </p>

          <h2 className="h2 text-2xl mt-8 mb-4">4. Diagnostic Results</h2>
          <p className="body mb-4">
            Our EDGE and CORE diagnostics are designed for professional development purposes. 
            Results should be considered as insights and guidance to support your leadership 
            journey, not as definitive psychological diagnoses. The diagnostics use AI-powered 
            analysis and are intended to complement, not replace, professional coaching and development.
          </p>

          <h2 className="h2 text-2xl mt-8 mb-4">5. PATH Programme Participation</h2>
          <p className="body mb-4">
            Acceptance into the PATH Programme cohort is at our discretion. Participants are 
            expected to engage fully with the programme, attend scheduled sessions, and maintain 
            confidentiality regarding other participants&apos; information.
          </p>

          <h2 className="h2 text-2xl mt-8 mb-4">6. Intellectual Property</h2>
          <p className="body mb-4">
            The content, features, methodology, and functionality of the PATH Programme are owned 
            by Organisation Logic Limited and are protected by copyright, trademark, and other 
            intellectual property laws. You may not reproduce, distribute, or create derivative 
            works without our written permission.
          </p>

          <h2 className="h2 text-2xl mt-8 mb-4">7. Limitation of Liability</h2>
          <p className="body mb-4">
            The PATH Programme is provided &ldquo;as is&rdquo; without warranties of any kind, either express 
            or implied. We shall not be liable for any indirect, incidental, special, or 
            consequential damages arising out of or in connection with your use of the service.
          </p>

          <h2 className="h2 text-2xl mt-8 mb-4">8. Governing Law</h2>
          <p className="body mb-4">
            These terms shall be governed by and construed in accordance with the laws of England 
            and Wales. Any disputes arising from these terms shall be subject to the exclusive 
            jurisdiction of the courts of England and Wales.
          </p>

          <h2 className="h2 text-2xl mt-8 mb-4">9. Changes to Terms</h2>
          <p className="body mb-4">
            We reserve the right to modify these terms at any time. We will notify users of any 
            material changes by email or through the service. Your continued use of the service 
            after such modifications constitutes acceptance of the updated terms.
          </p>

          <h2 className="h2 text-2xl mt-8 mb-4">10. Contact</h2>
          <p className="body mb-4">
            Questions about these Terms of Service should be sent to:
          </p>
          <p className="body mb-4">
            <strong>Email:</strong> hello@secretsauce.fyi<br />
            <strong>Company:</strong> Organisation Logic Limited<br />
            <strong>Registration:</strong> England & Wales Company Registration Number: 12213127
          </p>
        </div>
      </main>

      <LegalFooter />
    </div>
  );
}

export default TermsPage;
